import React from "react"
import PropTypes from "prop-types"
import { useFormikContext } from "formik"
import { useTranslation } from "react-i18next"
import TextError from "components/Shared/TextError"
import PhoneNumberField from "components/Shared/PhoneNumberField"
import { DEFAULT_PHONE_COUNTRY } from "utils/phoneUtils"

/**
 * International phone field with country flag + dial code for Formik forms.
 * Pass `countries` (ISO codes) to limit the selector; a single country hides the arrow.
 */
const FormikPhoneNumberField = ({
  name = "mobile",
  id,
  defaultCountry = DEFAULT_PHONE_COUNTRY,
  countries,
  disabled = false,
  className = "",
  placeholder,
}) => {
  const {
    values,
    setFieldValue,
    setFieldTouched,
    errors,
    touched,
  } = useFormikContext()
  const { t } = useTranslation()

  const hasError = Boolean(touched[name] && errors[name])
  const fieldId = id || name

  return (
    <div className={className}>
      <PhoneNumberField
        name={name}
        id={fieldId}
        value={values[name] || ""}
        onChange={value => setFieldValue(name, value || "")}
        onBlur={() => setFieldTouched(name, true, true)}
        defaultCountry={defaultCountry}
        countries={countries}
        disabled={disabled}
        placeholder={placeholder || t("Phone Number")}
        hasError={hasError}
      />
      <TextError name={name} />
    </div>
  )
}

FormikPhoneNumberField.propTypes = {
  name: PropTypes.string,
  id: PropTypes.string,
  defaultCountry: PropTypes.string,
  countries: PropTypes.arrayOf(PropTypes.string),
  disabled: PropTypes.bool,
  className: PropTypes.string,
  placeholder: PropTypes.string,
}

export default FormikPhoneNumberField
